import { h } from 'preact'
import Moment from 'moment'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Project = (props) => {

  let project = props.project
  let title  = project.title
  let excerpt  = project.excerpt
  let link  = project.url
  let raw_date = project.date
  let date = Moment(raw_date).format('DD/MM/YYYY')
  let feat_image = project.feat_image
  let company = project.company

  let text_show = 'Bekijk'

  if (props.language == 'en') {
    text_show = 'View'
    date = Moment(raw_date).format('MM/DD/YYYY')
  }

  return (
    <div className="c-project c-projects__col">

      <div className="c-project__image u-image">
        <a href={link} target="_blank" dangerouslySetInnerHTML={{ __html: feat_image }} />
      </div>

      <div className="c-project__body">
        <h3 className="c-project__title">
          <a
            href={link}
            target="_blank"
            className="c-project__link"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </h3>
        <p
          className="c-project__excerpt"
          dangerouslySetInnerHTML={{ __html: excerpt }}
        />
      </div>

      <div className="c-project__footer">

        <div className="c-project__details">
          <div className="c-project__date">
            {date}
          </div>

          <div
            className="c-project__branches c-project__branches__logo-holder"
            dangerouslySetInnerHTML={{ __html: company }}
          />
        </div>

        <div className="c-project__view">
          <a href={link} target="_blank" className="c-button c-project__button">
            {text_show}
            <svg class="c-icon c-icon--large c-project__icon">
              <use href="#arrow-thin-right" xlinkHref="#arrow-thin-right"></use>
            </svg>
          </a>
        </div>

      </div>

    </div>
  )
}

export default Project



// WEBPACK FOOTER //
// ./src/js/news/components/Project.js
